export default __webpack_public_path__ + "217987f1493f694b45fc5008e6ab29c9.ply";